import { useState } from "react";
import { PoolStakingConfig } from "../../../interfaces";
import { config } from "process";
import PartnerStake from ".";
import { Button, Grid } from "@material-ui/core";
import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from "react-icons/md";

const PartnerStakeWrapper = ({ poolData }: any) => {

  const [visibleCount, setVisibleCount] = useState(1);

  const handleShowMoreOrLess = () => {
    if (visibleCount < poolData.poolStakingConfigs.length) {
      setVisibleCount(prevCount => prevCount + 1);
    } else {
      setVisibleCount(1); // Reset to show only the first card
    }
  };

  const sortedConfigs=
    poolData?.poolStakingConfigs
    ?.map((config: PoolStakingConfig) => ({
      ...config,
      maxApy: Math.max(...config.withdrawalRules.map((rule) => rule.apy)),
    }))
    .sort((a: any, b: any) => b.maxApy - a.maxApy)
    .slice(0, visibleCount);

  if (!poolData || !poolData.poolStakingConfigs || poolData.poolStakingConfigs.length === 0) {
    return null;
  }

  return (
    <>
      {
        sortedConfigs?.map((config: PoolStakingConfig) => (
          <Grid item key={config.id}>
            <PartnerStake pool={poolData} poolStakingConfig={config} />
          </Grid>
        ))}
        {
          poolData?.poolStakingConfigs.length > 1 && (
            <Grid item style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px',
            }}>
              {
                visibleCount < poolData?.poolStakingConfigs.length
                  ? 
                    <Button color="primary" onClick={handleShowMoreOrLess} endIcon={<MdOutlineArrowDropDown />}> Show More </Button>
                  :
                    <Button color="primary" onClick={handleShowMoreOrLess} endIcon={<MdOutlineArrowDropUp />}> Show Less </Button>
              }
            </Grid>
          )
        }
    </>
  )
}

export default PartnerStakeWrapper;